import { Box, Button, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { tokens } from './../../../theme';

function ContactMessageBox({ contactMessage, onDeleteButtonClick, onReply }) {
    const colors = tokens();
    const [reply, setReply] = useState('');
    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');

    const sendReply = async () => {
        if (!reply.trim() || sending) return;
        setSending(true);
        setError('');
        try {
            await onReply(contactMessage, reply.trim());
            setReply('');
        } catch (err) {
            setError(err?.response?.data?.error?.message || err?.response?.data?.message || 'Yanıt gönderilemedi. Lütfen tekrar deneyin.');
        } finally {
            setSending(false);
        }
    };
    return (
        <Box display="flex" flexDirection="column" justifyContent="space-between" sx={{ gridColumn: "span 1", border: "1px solid " + colors.grey[500], borderRadius: "20px" }}>
            <Box padding="10px" display="flex" justifyContent="space-between" alignItems="center" >
                <Box display="flex" gap="10px" alignItems="center">
                    <Box component="img" src={contactMessage.user_profile_photo_link} alt={contactMessage.user_name} sx={{ objectFit: "cover", width: "50px", height: "50px", borderRadius: "25px" }} />
                    <Box>
                        <Typography variant="h3">{contactMessage.user_name} {contactMessage.user_surname}</Typography>
                        <Typography variant="h6">{(new Date(contactMessage.created_date)).toLocaleDateString()} {(new Date(contactMessage.created_date)).toLocaleTimeString()}</Typography>
                    </Box>
                </Box>
            </Box>
            <Box component="hr" height="1px" width="100%" sx={{ background: "black", border: "0px", margin: "0px" }} />
            <Box padding="10px">
                <Typography variant='h5' mt="10px">{contactMessage.message}</Typography>
                {contactMessage.reply != null ? (
                    <Box mt="20px" p="12px" sx={{ borderRadius: '12px', backgroundColor: colors.blueAccent[900] }}>
                        <Typography variant="h6">Yanıtlandı · {contactMessage.replied_date ? new Date(contactMessage.replied_date).toLocaleString() : ''}</Typography>
                        <Typography variant="h5" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{contactMessage.reply}</Typography>
                    </Box>
                ) : (
                    <Box mt="20px">
                        <TextField
                            fullWidth multiline minRows={3} maxRows={8} inputProps={{ maxLength: 4000 }}
                            label="Kullanıcıya yanıt" value={reply}
                            onChange={(event) => setReply(event.target.value)}
                            helperText={error || 'Yanıt, kullanıcının uygulama içi bildirimlerine kaydedilir.'}
                            error={Boolean(error)}
                        />
                        <Button variant="contained" disabled={!reply.trim() || sending} onClick={sendReply} sx={{ mt: 1 }}>
                            {sending ? 'Gönderiliyor...' : 'Yanıtı Gönder'}
                        </Button>
                    </Box>
                )}
            </Box>
            <Box display="flex" gap="10px" padding="10px" justifyContent="end">
                <Button variant="contained" color="error" sx={{ width: "35%", borderRadius: "12px" }} onClick={() => onDeleteButtonClick()}>Mesajı Sil</Button>
            </Box>
        </Box>
    )
}

export default ContactMessageBox
